import React from 'react';
import { PageType } from 'enums';
import { createFetchPageAction } from 'page/actions';
import { fetchScheduleModule } from 'scheduleModule/actions';
import TopLayoutContainer from './common/TopLayoutContainer';
import BucketListContainer from './buckets/BucketListContainer';
import MainContainer from './common/MainContainer';

const ShortStopLive = () => (
    <MainContainer className="watch-home">
        <TopLayoutContainer />
        <div className="layout-full layout-full--watch">
            <section className="col-a">
                <BucketListContainer pageType={PageType.HOME} />
            </section>
        </div>
    </MainContainer>
);

ShortStopLive.loadActions = [
    (params, query, lang) => createFetchPageAction('shortstoplive', params, query, lang),
    (params, query, lang) => fetchScheduleModule(query, lang)
];

export default ShortStopLive;



// WEBPACK FOOTER //
// ./app/page/ShortStopLive.js